import { IconWrapper } from '../runtime';
export default IconWrapper('sticky_note_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#E8B600"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#DBAC00"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#F7C200"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#E8B600"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.25735 12.9861C8.52138 12.9218 9.58298 12.6944 11.4093 11.1395C12.9 9.64387 13.7768 7.38418 14.2492 5.75755C14.2743 5.67126 14.2982 5.58674 14.321 5.50422C14.6066 4.47115 14.7188 3.75 14.7188 3.75C14.7188 3.75 14 3.8625 12.9703 4.14906C12.8861 4.17251 12.7998 4.19698 12.7118 4.22251C11.0946 4.69161 8.88197 5.52129 7.45058 7.07045C5.81545 8.84011 5.48169 10.9124 5.4177 12.1783C5.41719 12.1884 5.4167 12.1984 5.41623 12.2083L3.1875 14.25L5.60867 14.1942C5.84565 14.1942 6.0739 14.117 6.26074 13.9775C6.31897 13.934 6.37318 13.8845 6.42237 13.8294C6.42618 13.8252 6.42995 13.8209 6.43369 13.8166L7.25735 12.9861ZM7.43927 11.0953C7.82613 11.0629 8.11767 11.0036 8.42943 10.8796C8.82076 10.7239 9.35058 10.4221 10.1325 9.76382C10.9786 8.8904 11.6138 7.62409 12.0639 6.40508C10.8486 6.85069 9.63384 7.47044 8.82772 8.34289C8.01459 9.22293 7.62415 10.2162 7.43927 11.0953Z",
      "fill": "white"
    }
  })]);
});